import styled from 'styled-components';
import { Input as AntdInput } from 'antd';
import React from 'react';

const InputStyled = styled(AntdInput)`
  border-width: 0;
  font-weight: 500;
  font-size: 30px;
  width: 100%;
  border-radius: 0.4em;
  padding: 0.16em 0.58em 0.14em 0.58em;
  text-align: left;

  :focus {
    outline: none;
  }

  :focus-visible {
    outline: 3px solid #008939;
    outline-offset: 2px;
    box-shadow: none;
  }

  display: inline-block;
  transition: all 300ms;
`;

const Input = ({ ...props }) => {
  const inputRef = React.useRef(null);

  return <InputStyled {...props} ref={inputRef} onKeyPress={e => {
    if (e.key === 'Enter') {
      inputRef.current.blur();
    }
  }}
  />;
};

export default Input;
